import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { api } from "@/lib/api";
import { useStore } from "@/context/StoreContext";
import { Reveal } from "@/components/Reveal";
import { useSeo } from "@/lib/seo";

export default function Categories() {
  const { t } = useStore();
  const [groups, setGroups] = useState(null);
  useSeo({ title: t("shopByCategory"), description: "Shop CASABLANCA by category: shoes, gender, sport, brands, popular models, season and sales." });
  useEffect(() => { api.get("/categories").then((r) => setGroups(r.data)).catch(() => setGroups([])); }, []);
  const total = groups?.[0]?.items?.[0]?.count ?? 0;

  return (
    <main className="pb-24" data-testid="categories-page">
      <div className="container-x pb-14 pt-16">
        <Reveal>
          <p className="eyebrow mb-4 text-ink/50">{t("productCategories")}</p>
          <h1 className="font-display text-6xl font-black uppercase leading-[0.85] tracking-tighter sm:text-8xl lg:text-9xl">{t("shopByCategory")}</h1>
          {groups && total === 0 && <p className="mt-6 max-w-lg text-ink/60" data-testid="categories-empty-note">{t("catEmpty")}</p>}
        </Reveal>
      </div>
      <div className="container-x"><div className="grid gap-px bg-ink/10 sm:grid-cols-2 lg:grid-cols-4" data-testid="category-groups">
        {(groups || []).map((g, gi) => (
          <Reveal key={g.slug} delay={(gi % 4) * 0.05} className="bg-sun p-7 sm:p-9">
            <section data-testid={`category-group-${g.slug}`}>
              <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-ink/40">{String(gi + 1).padStart(2, "0")}</p>
              <h2 className="mt-2 font-display text-2xl font-black uppercase tracking-tight">{g.label}</h2>
              <ul className="mt-6 space-y-1">
                {g.items.map((it) => (
                  <li key={it.slug}>
                    <Link to={`/shop?cat=${it.slug}`} data-testid={`category-link-${it.slug}`}
                      className="group flex items-center justify-between border-b border-ink/10 py-2.5 text-[15px] transition-[padding] duration-300 hover:pl-2">
                      <span className="link-u">{it.label}</span>
                      <span className="flex items-center gap-2 font-mono text-xs text-ink/40">
                        {it.count}
                        <ArrowUpRight className="h-3.5 w-3.5 opacity-0 transition-opacity group-hover:opacity-100" />
                      </span>
                    </Link>
                  </li>
                ))}
              </ul>
            </section>
          </Reveal>
        ))}
      </div></div>
    </main>
  );
}
